export const globalStyles = `
 .pr-faceoff-review,
  .pr-rd-description-text,
  .pr-faceoff-review span {
    text-align: left;
    line-height: 18px !important;
    font-size: 16px !important;
    letter-spacing: 0px;
    color: #373a36 !important;
    opacity: 1;
  }
  .p-w-r .pr-snippet {
    display: flex;
    flex-direction: column;
  }

  .pr-faceoff-title,
  .pr-rd-review-headline,
  .pr-rd-review-total {
    text-align: left;
    line-height: 22px !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    letter-spacing: 0px;
    color: #373a36 !important;
    opacity: 1;
  }

  .pr-faceoff-readcomplete,
  .pr-faceoff-readcomplete-expanded {
    text-align: left;
    line-height: 22px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    letter-spacing: 0px;
    color: #1d8634 !important;
    opacity: 1;
  }
pr-star-v4-100-filled
  .pr-caret-icon {
    display: none;
  }

  .pr-faceoff-label {
    text-align: left;
    line-height: 22px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    letter-spacing: 0px;
    color: #373a36 !important;
    opacity: 1;
  }

  .p-w-r {
    font-family: 'Rubik', Arial, sans-serif !important;
  }

  .pr-rd-bold {
    font-weight: 500 !important;
  }

  .pr-rd-details > span,
  .pr-rd-details > time,
  .pr-rd-details > span > span,
  span.pr-rd-badging-text {
    text-align: left;
    line-height: 18px !important;
    font-size: 14px !important;
    letter-spacing: 0px;
    color: #373a36 !important;
  }

  .pr-rd-reviewer-details p span time,
  .pr-rd-review-position > span {
    text-align: left;
    line-height: 18px !important;
    font-size: 14px !important;
    letter-spacing: 0px;
    color: #373a36 !important;
    font-weight: 400 !important;
  }

  .pr-rd-review-position {
    .pr-rd-bold {
      font-weight: 400 !important;
    }
  }

  .pr-rd-bottomline > span,
  .pr-rd-helpful-text {
    line-height: 22px !important;
    font-size: 14px !important;
    letter-spacing: 0px;
    color: #373a36 !important;
    font-weight: 400 !important;
  }

  span.pr-rd-bold,
  span.pr-rd-badging-text {
    font-weight: 500 !important;
  }

  .pr-rd-flag-review-btn,
  .pr-rd-to-top,
  .pr-rd-pagination-btn {
    text-align: left;
    font-size: 14px !important;
    letter-spacing: 0px;
    font-weight: 500 !important;
    color: #1d8634 !important;
    text-decoration: none !important;
  }

  .pr-search-icon {
    margin-top: 5px !important;
    width: 33px !important;

    svg path {
      fill: #1d8634 !important;
    }
  }

  .pr-rd-search-reviews-icon-button {
    background-color: #ffffff !important;
    border-left: 1px solid #8c8c8c !important;
    border-bottom: 1px solid #8c8c8c !important;
  }

  .pr-badging-icon svg g circle {
    fill: #1d8634 !important;
  }

  .pr-rd-sort {
    border-radius: 5px !important;
  }

  .pr-snippet-review-count {
    padding: 0 7.5px 0 0 !important;
  }

  .pr-rd-search-reviews-input input {
    border-radius: 5px !important;
  }

  .pr-rd-search-reviews-icon-button {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
  }

  .pr-star-v4-100-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjRkY2QTE0IiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZmlsbD0iI0ZGRiIgZD0ibTEwIDEzLjUtNC4xMTQgMi4xNjMuNzg1LTQuNTgxLTMuMzI4LTMuMjQ1IDQuNi0uNjY5TDEwIDNsMi4wNTcgNC4xNjggNC42LjY2OS0zLjMyOCAzLjI0NS43ODUgNC41ODF6Ii8+PC9nPjwvc3ZnPg==) !important;
  }

  .pr-star-v4-50-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjREVERURFIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZD0iTTIgMGg4djIwSDJhMiAyIDAgMCAxLTItMlYyYTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjRkY2QTE0Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0ibTEwIDEzLjUtNC4xMTQgMi4xNjMuNzg1LTQuNTgxLTMuMzI4LTMuMjQ1IDQuNi0uNjY5TDEwIDNsMi4wNTcgNC4xNjggNC42LjY2OS0zLjMyOCAzLjI0NS43ODUgNC41ODF6Ii8+PC9nPjwvc3ZnPg==) !important;
  }

  .pr-star-v4-75-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjREVERURFIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZD0iTTIgMGgxM3YyMEgyYTIgMiAwIDAgMS0yLTJWMmEyIDIgMCAwIDEgMi0yeiIgZmlsbD0iI0ZGNkExNCIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Im0xMCAxMy41LTQuMTE0IDIuMTYzLjc4NS00LjU4MS0zLjMyOC0zLjI0NSA0LjYtLjY2OUwxMCAzbDIuMDU3IDQuMTY4IDQuNi42NjktMy4zMjggMy4yNDUuNzg1IDQuNTgxeiIvPjwvZz48L3N2Zz4=) !important;
  }

  .pr-star-v4-25-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjREVERURFIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZD0iTTIgMGgzdjIwSDJhMiAyIDAgMCAxLTItMlYyYTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjRkY2QTE0Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0ibTEwIDEzLjUtNC4xMTQgMi4xNjMuNzg1LTQuNTgxLTMuMzI4LTMuMjQ1IDQuNi0uNjY5TDEwIDNsMi4wNTcgNC4xNjggNC42LjY2OS0zLjMyOCAzLjI0NS43ODUgNC41ODF6Ii8+PC9nPjwvc3ZnPg==) !important;
  }

  .pr-ratings-histogram-barValue {
    background: #ff6a14 !important;
  }

  .pr-headline {
    line-height: 22px !important;
    font-size: 24px !important;
    letter-spacing: 0px;
    color: #373a36 !important;
    font-weight: 500 !important;
  }

  .pr-review-snapshot-snippets-headline {
    font-size: 50px !important;
    letter-spacing: 0px;
    color: #373a36 !important;
    font-weight: 400 !important;
  }

  .pr-review-snapshot-block-container {
    .pr-reco-to-friend-message {
      @include text(venus);
      font-size: 14px !important;
    }
  }

  .pr-snippet-rating-decimal {
    font-size: 9px !important;
    line-height: 14px !important;
    color: #373a36 !important;
    font-weight: 400 !important;
  }

  .pr-review-snapshot-snippets {
    .pr-snippet-write-review-link {
      color: #373a36 !important;
      font-family: Rubik !important;
      background-color: #ffffff !important;
      border-radius: 24px !important;
      display: inline-block !important;
      text-decoration: none !important;
      transition: background-color 0.2s !important;
      cursor: pointer !important;
      text-align: center !important;
      box-sizing: border-box !important;
      padding: 12px 70px !important;
      border: 1px solid #373a36 !important;
    }

    .pr-snippet-review-count {
      line-height: 22px !important;
      font-size: 14px !important;
      letter-spacing: 0px;
      color: #373a36 !important;
      font-weight: 400 !important;
    }
  }

  .pr-snippet-write-review-link,
  .pr-snippet-review-count {
    color: #1d8634 !important;
  }
  #pr-write-review {
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 700px) {
      margin-left: 30px;
      margin-right: 30px;
    }
  }

  .p-w-r .pr-textinput::placeholder {
    font-size: 14px;
  }
  .pr-rd-search-reviews-input {
    input::placeholder {
      font-size: 14px;
    }
  }

  [data-pr-component='ReviewSnippet'] {
    .p-w-r {
      .pr-no-reviews {
        .pr-snippet-stars-container {
          display: none !important;
        }
      }
    }
  }
`
